import React, { Component } from "react";
import { Typography, Checkbox, withStyles, WithStyles } from "@material-ui/core";
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
// import { showMsg } from '../../components/course/actions/loaderAlert';
import { setCountToImport, selectAllCheckbox, setSelectAll, setSelectedQuestionsBySelectAll } from '../../components/mylibrary/reducers/bulkimportReducer';
import { generateDefaultData } from '../content-request/helpers/createContentRequest';
import contentRequestServices from '../content-request/services/contentRequestServices';
import { showMsg } from '../course/actions/loaderAlert';
import { connect } from 'react-redux'
import {
  createStyles, Button, Grid
} from '@material-ui/core';
import { MyPATLink } from ".";
import { formValueSelector } from "redux-form";
import AddIcon from '@material-ui/icons/Add';
import { contentRequestAccordianActions } from "../content-request/reducers/contentRequestAccordianState";
import { CodeSharp } from "@material-ui/icons";
import { withRouter } from "react-router-dom";


const styles = (theme: Theme) => createStyles({
  root: {
    flex: 'grow'
  },
  textAlignRight: {
    textAlign: "right"
  },
  mb1x: {
    marginBottom: theme.spacing.unit
  },
  questionParagraph: {
    maxWidth: 535,
    '& >p': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      margin: '0',
    },
  },
  pTagmargin: {
    '& >p:first-child': {
      margin: '0',
    },

  },
  questionInfo: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 4,
    // padding: '0 15px',
    "& > div": {
      padding: `0 ${theme.spacing.unit}px`
    },
    "& > div:first-child": {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
    },
    '& img': {
      padding: "0 10px",
    }
  },
  tabsContainer: {
    border: 'solid 1px #E1E1E1',
    margin: '25px 0 10px 0',
    padding: '20px',
    borderRadius: '5px',
    "position": "relative",
    '& label': {
      fontSize: 20,
      lineHeight: "22px",
      color: "#333333",
    },
  },
  orText: {
    background: "#E0E6E7",
    height: "40px",
    width: "40px",
    borderRadius: "100%",
    fontStyle: "italic",
    fontSize: 14,
    color: "#989898",
    display: "inline-flex",
    alignItems: 'center',
    justifyContent: 'center',
    position: "absolute",
    top: "-20px",
    left: "50%",
    marginLeft: '-20px',
  },
  buttonRed: {
    borderLeft: "1px solid #e0e0e0",
    borderRadius: 0,
    color: '#F23C3C',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },

  justifyEnd: {
    justifyContent: 'flex-end',
  },
  idSpacing: {
    marginRight: '15px',
  },
});

interface Props extends WithStyles<typeof styles> {
  checkboxVisiblity: boolean,
  checkBoxAdd?: boolean,
  accordianIndex: any,
  saveReset?: boolean,
  importCreate?: boolean,
  handleCreate: Function,
  count?: number,
  selectAll: any,
  handleChooseFromLibrary: Function;
  contentId?: string,
  content_Id: string,
  handleReset: Function,
  setCountToImport: any;
  progressBar: any,
  progressBarForQuestion: any,
  progressBarForTest: any,
  setProgressBarForQuestion: Function,
  setProgressBarForTest: Function,
  type: string,
  contentRequestItemsId: string,
  contentRequestId: string,
  isJobCompleted: boolean,
  status: string;
  showMsg: any,
  selectedQuestionsBySelectAll: any,
  handleSaveQuestion: Function;
  isTestRequest: boolean,
  handleSaveTest: Function,
  testDetails: any,
  handleCheckboxState: Function,
  checkAll: any,
  removeQuestionFromCheckboxState: Function,
  questionTabDetails: any,
  checkboxDisable: boolean,
  contentRequestItemsIdForFirstTime: string;
  urlRequestType: string,
  indexCount: boolean,
  code: string,
  HandleSelectAll: Function,
  passageData: any,
  typeOfContent: string,
  contentRequestStateData: any,
  overallStatus: boolean,
  accordianState: any,
  selectAllCheckbox: Function,
  setSelectAll: Function,
  setSelectedQuestionsBySelectAll: Function,
  questionIndex: number,
  setIsClickedOnImport: Function,
  unresolvedFeedbackCount?: number,
  handleResetQuestionForUnresolvedCount: Function;
  handleChooseFromLibraryForUnresolvedContent: Function;
  setRemoveUnresolvedFeedbackCount: Function;
  previousVersion: any,
  newVersion: any,
  removeUnresolvedFeedbackCount: any;
  handleSaveQuestionForUnresolvedContent: Function;
  handleSaveTestForUnresolvedCount: Function;
  setRemoveUnresolvedFeedbackCountForTest: Function;
  removeUnresolvedFeedbackCountForTest: number;
  requestId: string;
  match: any;
}

interface State {
  //expanded: boolean;
  countCheck: number;
  flagCheck: boolean,
  checked: boolean,
  showsaveButton: boolean;
  showQuestionID: boolean;
  jobDoneIcon: boolean;
  isJobDone: boolean;
  selectAllDataCount: number;
  // isJobCompleted: boolean;
}

class MyPATQuestionBar extends Component<Props, State> {
  // public static defaultProps = {
  //   isTestRequest:false
  // };
  constructor(props: Props) {
    super(props);
    this.state = {
      //  expanded: props.expanded || false,
      countCheck: 0,
      flagCheck: false,
      checked: false,
      selectAllDataCount: 0,
      showsaveButton: !this.props.isJobCompleted,
      showQuestionID: true,
      jobDoneIcon: false,
      isJobDone: false
      // isJobCompleted: false
    };
  }


  handleSave = async () => {
    const { setProgressBarForQuestion, setProgressBarForTest, type,
      content_Id, count, contentRequestItemsId,
      contentRequestId, handleSaveQuestion, isTestRequest,
      handleSaveTest, testDetails, contentRequestItemsIdForFirstTime,
      typeOfContent, unresolvedFeedbackCount,
      handleSaveQuestionForUnresolvedContent, handleSaveTestForUnresolvedCount }
      = this.props
    this.setState({ jobDoneIcon: true });
    if (unresolvedFeedbackCount) {
      const { newVersion, previousVersion } = this.props;
      const { content_Id: newId } = newVersion;
      const { content_Id: resetId } = previousVersion;
      const body = {
        contentRequestItemId: isTestRequest ? testDetails.contentRequestItemsId._id : contentRequestItemsId,
        "resetContentId": resetId.substring(0, 24),
        "newContentId": newId.substring(0, 24)
      }
      contentRequestServices.resetForUnresolvedCount(body).then(async (response: any) => {
        if (response.statusCode === 200) {
          const contentID = content_Id.substring(0, 24);
          try {
            let data;
            let dataForParaGraphQuestion: any = [];
            const paraGraphQuestionData = this.props.accordianState
            if (isTestRequest) {
              if (!testDetails.contentRequestItemsId) {
                data = generateDefaultData(contentRequestId, contentID, 'test', contentRequestItemsIdForFirstTime);
              } else {
                data = generateDefaultData(contentRequestId, contentID, 'test', testDetails.contentRequestItemsId._id);
              }
            }
            else {
              if (!contentRequestItemsId) {
                data = generateDefaultData(contentRequestId, contentID, 'question', contentRequestItemsIdForFirstTime);
              } else {
                data = generateDefaultData(contentRequestId, contentID, 'question', contentRequestItemsId);
              }
            }

            const response = await contentRequestServices.getJobDoneApi(data);
            const { contentRequestStateData } = this.props;
            const { requestInfo: { details: { subjects = {} } = {} } = {} } = contentRequestStateData;
            let filterArray: any = [];
            subjects && subjects.length && subjects.map((val: any) => {
              const { questions = [] } = val;
              questions.map((val: any) => {
                filterArray.push(val);
              })
            })

            if (response.statusCode === 200) {
              if (typeOfContent === 'question' || typeOfContent === 'Question' || (typeOfContent === 'test' && filterArray.length)) {
                const { progressBarForQuestion: { count = 0 } = {} } = this.props;
                setProgressBarForQuestion({ count: count + 1 });
              } else {
                const { progressBarForTest: { count = 0 } = {} } = this.props;
                setProgressBarForTest({ count: count + 1 })
              }
              this.setState({
                showsaveButton: false,
                showQuestionID: true,
                isJobDone: true,
              }, () => {
                if (isTestRequest) {
                  handleSaveTestForUnresolvedCount()
                  this.props.setRemoveUnresolvedFeedbackCountForTest({
                    removeUnresolvedFeedbackCountForTest: this.props.removeUnresolvedFeedbackCountForTest + unresolvedFeedbackCount
                  });

                }
                else {
                  handleSaveQuestionForUnresolvedContent();
                  this.props.setRemoveUnresolvedFeedbackCount({
                    removeUnresolvedFeedbackCount: { ...this.props.removeUnresolvedFeedbackCount, [`acc${this.props.accordianIndex}`]: unresolvedFeedbackCount }
                  });
                }
              })

            }
            else {
              this.props.showMsg(response.responseMessage, 'error')
            }
          } catch (error) {
          };

        }
      });

    } else {
      const contentID = content_Id.substring(0, 24);
      try {
        let data;
        let dataForParaGraphQuestion: any = [];
        const paraGraphQuestionData = this.props.accordianState
        if (isTestRequest) {
          if (!testDetails.contentRequestItemsId) {
            data = generateDefaultData(contentRequestId, contentID, 'test', contentRequestItemsIdForFirstTime);
          } else {
            data = generateDefaultData(contentRequestId, contentID, 'test', testDetails.contentRequestItemsId._id);
          }
        } else {
          if (!contentRequestItemsId) {
            data = generateDefaultData(contentRequestId, contentID, 'question', contentRequestItemsIdForFirstTime);
          } else {
            data = generateDefaultData(contentRequestId, contentID, 'question', contentRequestItemsId);
          }
        }

        const response = await contentRequestServices.getJobDoneApi(data);
        const { contentRequestStateData } = this.props;
        const { requestInfo: { details: { subjects = {} } = {} } = {} } = contentRequestStateData;
        let filterArray: any = [];
        subjects && subjects.length && subjects.map((val: any) => {
          const { questions = [] } = val;
          questions.map((val: any) => {
            filterArray.push(val);
          })
        })

        if (response.statusCode === 200) {
          if (typeOfContent === 'question' || typeOfContent === 'Question' || (typeOfContent === 'test' && filterArray.length)) {
            const { progressBarForQuestion: { count = 0 } = {} } = this.props;
            setProgressBarForQuestion({ count: count + 1 });
          } else {
            const { progressBarForTest: { count = 0 } = {} } = this.props;
            setProgressBarForTest({ count: count + 1 })
          }
          this.setState({
            showsaveButton: false,
            showQuestionID: true,
            isJobDone: true,
          }, () => (isTestRequest) ? handleSaveTest() : handleSaveQuestion())
        }
        else {
          this.props.showMsg(response.responseMessage, 'error')
        }
      } catch (error) {
      };
    }
  }

  handleResetFunction = async () => {
    const { handleReset, isTestRequest, unresolvedFeedbackCount, handleResetQuestionForUnresolvedCount } = this.props;
    if (unresolvedFeedbackCount) {
      handleResetQuestionForUnresolvedCount();
      this.setState({
        showsaveButton: true,
        showQuestionID: false,
        jobDoneIcon: false,
        isJobDone: false,
      })
    } else {
      const isDataResetable = await handleReset();
      if(isDataResetable){
        this.setState({
          showsaveButton: true,
          showQuestionID: false,
          jobDoneIcon: false,
          isJobDone: false,
        })
      }
    }
    
  }

  handleIfCheckboxChecked = (disabled: any, singleCheck: any, checkAll: any) => {
    let result
    // if(singleCheck)
    //   result = true
    // if(checkAll)
    //   result = true
    // this.props.setSelectAll({
    //   item: false,
    // })
    // this.props.selectAllCheckbox({
    //   item:
    // });
    // if (disabled) {
    //   return false;
    // }
    // else if (singleCheck) {

    // }
    if (!disabled) {
      if (checkAll) {
        if (singleCheck) {

          return false
        }
        else {
          return true
        }
      }
      if (singleCheck) {
        if (checkAll) {
          return true
        }
        else {
          return true
        }
      }
      else
        return false
    }
    else
      return false
    return result
  }


  countBtn = (flag: any) => {
    if (flag === true) {
      this.props.handleCheckboxState();
    }
    if (flag === false) {
      this.props.removeQuestionFromCheckboxState()
    }
  }
  handleQuestionCheck = (checkData: any): boolean => {
    return true;
  }

  handleImportQuestion = () => {
    const { unresolvedFeedbackCount } = this.props;
    if (unresolvedFeedbackCount) {
      this.props.handleChooseFromLibraryForUnresolvedContent();
    } else {
      this.props.handleChooseFromLibrary()
    }
    this.props.setIsClickedOnImport({ booleanValue: true });
  }

  render() {
    const {
      classes,
      saveReset,
      importCreate,
      count,
      handleCreate,
      contentId,
      content_Id,
      isJobCompleted,
      isTestRequest,
      urlRequestType,
      typeOfContent
    } = this.props;


    let number: any;
    number = 0;
    return (
      <>
        <Grid
          container
          spacing={8}
          alignItems="center"
          justify="space-between"
          wrap="nowrap"
          className={classes.mb1x}
        >
          <Grid item>
            {(typeOfContent !== 'Test' && typeOfContent !== 'test') ? (
              <Checkbox
                disabled={this.props.checkAll && this.props.checkAll[this.props.accordianIndex] && this.props.checkAll[this.props.accordianIndex]['questionCheck'] && (this.props.checkAll[this.props.accordianIndex]['disabledCheck'][`ACCDISABLE${this.props.accordianIndex}${this.props.questionIndex}`]) ? true : false}
                checked={this.props.checkAll && this.props.checkAll[this.props.accordianIndex] && this.props.checkAll[this.props.accordianIndex]['questionCheck'] && (this.props.checkAll[this.props.accordianIndex]['questionCheck'][`ACC${this.props.accordianIndex}${this.props.questionIndex}`]) ? true : false}
                onChange={(e) => {
                  if (!e.target.checked) {
                    const { selectAll = {} } = this.props;
                    let cloneSelectAll = { ...selectAll };
                    cloneSelectAll[`ACC${this.props.accordianIndex}`] = false;
                    const { checkAll = [] } = this.props;
                    let updateCheckAll = [...checkAll];
                    updateCheckAll[this.props.accordianIndex] = {
                      ...updateCheckAll[this.props.accordianIndex],
                      questionCheck: {
                        ...updateCheckAll[this.props.accordianIndex]['questionCheck'],
                        [`ACC${this.props.accordianIndex}${this.props.questionIndex}`]: false
                      }
                    }
                    const { questionCheck = {} } = updateCheckAll[this.props.accordianIndex];
                    let isSelected = false;
                    questionCheck && Object.keys(questionCheck).forEach((element: any) => {
                      if (questionCheck[element]) {
                        isSelected = true;
                      }
                    })
                    updateCheckAll[this.props.accordianIndex] = {
                      ...updateCheckAll[this.props.accordianIndex],
                      isSelected
                    }
                    this.props.selectAllCheckbox({
                      item: [...updateCheckAll]
                    })
                    this.props.setSelectAll({
                      item: { ...this.props.selectAll, ...cloneSelectAll }
                    });
                    const { accordianIndex, questionIndex, removeQuestionFromCheckboxState } = this.props;
                    removeQuestionFromCheckboxState(accordianIndex, questionIndex);
                  }
                  else {
                    const { checkAll = [] } = this.props;
                    let { questionCheck = {} } = checkAll[this.props.accordianIndex];
                    let questionCheckKeys = Object.keys(questionCheck);
                    let checkCount = 0;
                    questionCheckKeys && questionCheckKeys.length && questionCheckKeys.forEach((element: any) => {
                      if (questionCheck[element]) {
                        checkCount = checkCount + 1;
                      }
                    })
                    if (checkCount === questionCheckKeys.length) {
                      const { selectAll = {} } = this.props;
                      let cloneSelectAll = { ...selectAll };
                      cloneSelectAll[`ACC${this.props.accordianIndex}`] = true;
                      this.props.setSelectAll({
                        item: { ...this.props.selectAll, ...cloneSelectAll }
                      });
                    } else {
                      const { checkAll = [] } = this.props;
                      let updateCheckAll = [...checkAll];
                      updateCheckAll[this.props.accordianIndex] = {
                        ...updateCheckAll[this.props.accordianIndex],
                        questionCheck: {
                          ...updateCheckAll[this.props.accordianIndex]['questionCheck'],
                          [`ACC${this.props.accordianIndex}${this.props.questionIndex}`]: true
                        }
                      }
                      const { questionCheck: questionCheckForIsSelected = {} } = updateCheckAll[this.props.accordianIndex];
                      let isSelected = false;
                      questionCheckForIsSelected && Object.keys(questionCheckForIsSelected).forEach((element: any) => {
                        if (questionCheckForIsSelected[element]) {
                          isSelected = true;
                        }
                      })
                      updateCheckAll[this.props.accordianIndex] = {
                        ...updateCheckAll[this.props.accordianIndex],
                        isSelected: isSelected
                      }
                      this.props.selectAllCheckbox({
                        item: [...updateCheckAll]
                      })
                      checkCount = 0;
                      let checkCounForDisable = 0;
                      const { questionCheck: questionCheckForUpdate = [], disabledCheck: disabledCheckForUpdate = {} } = updateCheckAll[this.props.accordianIndex];
                      questionCheckKeys && questionCheckKeys.length && questionCheckKeys.forEach((element: any, index: number) => {
                        if (questionCheckForUpdate[element] && !disabledCheckForUpdate[`ACCDISABLE${this.props.accordianIndex}${index + 1}`]) {
                          checkCount = checkCount + 1;
                        }
                      })
                      const { disabledCheck = {} } = updateCheckAll[this.props.accordianIndex];
                      const disabledKeys = Object.keys(disabledCheck);
                      disabledKeys && disabledKeys.length && disabledKeys.forEach((element: any) => {
                        if (disabledCheck[element]) {
                          checkCounForDisable = checkCounForDisable + 1;
                        }
                      })
                      if (checkCount === (questionCheckKeys.length - checkCounForDisable)) {
                        const { selectAll = {} } = this.props;
                        let cloneSelectAll = { ...selectAll };
                        cloneSelectAll[`ACC${this.props.accordianIndex}`] = true;
                        this.props.setSelectAll({
                          item: { ...this.props.selectAll, ...cloneSelectAll }
                        });
                      }
                    }
                    const { accordianIndex, questionIndex, handleCheckboxState } = this.props;
                    handleCheckboxState(accordianIndex, questionIndex);
                  }
                }}
                color="primary"
              />) : <></>}

          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              alignItems="center"
              className={classes.questionInfo}
            >
              {/* <Grid item xs={9}
              >
                <Typography variant="body1"
                  classes={{ root: classes.questionParagraph }}
                  noWrap>
                  { isTestRequest &&
                    <span className={classes.pTagmargin} dangerouslySetInnerHTML={{ __html: `Test ${count}` }} />
                  }  
                  { !isTestRequest &&
                    <span className={classes.pTagmargin} dangerouslySetInnerHTML={{ __html: `Q${count}` }} />
                  }
                </Typography>
              </Grid> */}

              <Grid item xs={8} className={classes.flex}>
                <Typography variant="body1"
                  classes={{ root: classes.questionParagraph }}
                  noWrap>
                  {isTestRequest &&
                    <span className={classes.pTagmargin} dangerouslySetInnerHTML={{ __html: `Test ${count}` }} />
                  }
                  {!isTestRequest &&
                    <span className={classes.pTagmargin} dangerouslySetInnerHTML={{ __html: `Q${count}` }} />
                  }
                </Typography>
                {isJobCompleted ? (<span className={classes.flex}> <img src="/assets/svg/contentRequest/step-done.svg" /></span>) : (
                  (isJobCompleted && this.state.showsaveButton) && (<Button> <img src="/assets/svg/contentRequest/step-done.svg" /></Button>))}

              </Grid>
              <Grid item xs={4} className={[classes.flex, classes.justifyEnd].join(' ')}>
                {/* <Grid container justify="space-between" alignItems="center" wrap="nowrap">
                <Grid item xs={12}> */}
                {(contentId) && (<>
                  {(!isJobCompleted || this.state.showQuestionID) && (<Typography className={classes.idSpacing} variant="body1" noWrap>
                    {/* <span>Q1.</span> */}
                    {(<span><MyPATLink to={`/content/preview/${content_Id.substring(0,24)}${urlRequestType}/${this.props.requestId}?contentRequestId=${this.props.contentRequestId}&contentRequestItemsId=${this.props.contentRequestItemsId}&authorType=${this.props.match.params.role}`} target="_blank">
                      {contentId && contentId.toUpperCase()}
                    </MyPATLink></span>)}
                  </Typography>)}
                  {/* {this.state.showQuestionID  && (<Typography variant="body1" noWrap>
                  ID: <span><MyPATLink to={`/content/preview/${content_Id}question`} target="_blank">
                    {contentId.toUpperCase()}
                  </MyPATLink></span>
                </Typography>)} */}
                </>)
                }
                {importCreate && (
                  <Typography variant="body1" className={classes.textAlignRight}>
                    {!isTestRequest &&
                      <Button style={{ 'color': '#21A67A' }} onClick={() => { this.handleImportQuestion() }}><img src="/assets/svg/upload-icon.svg" />IMPORT</Button>
                    }
                    <Button color="primary" onClick={() => { handleCreate() }} ><AddIcon />&nbsp;CREATE</Button>
                  </Typography>
                )}
                {/* </Grid>

              </Grid> */}
                {saveReset && (
                  // <Grid container justify="flex-end" alignItems="center">
                  <Typography variant="body1" noWrap>
                    {(!isJobCompleted || this.state.showsaveButton) && (<Button color="primary" onClick={() => this.handleSave()}  >SAVE</Button>)}
                    {(!this.props.overallStatus || Boolean(this.props.unresolvedFeedbackCount)) && <Button className={classes.buttonRed} onClick={() => this.handleResetFunction()}>RESET</Button>}
                  </Typography>
                  // </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </>
    );
  }
}
const mapstatetoprops = (state: any) => ({
  checkAll: _.get(state, 'bulkImportCount.checkAll', []),
  accordianState: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianState', []),
  selectedQuestionsBySelectAll: _.get(state, 'bulkImportCount.selectedQuestionsBySelectAll', []),
  questionTabDetails: _.get(state, 'bulkImportCount.questionTabDetails', {}),
  contentRequestItemsIdForFirstTime: _.get(state, 'contentRequestData.contentRequestAccordianData.contentRequestItemsIdForFirstTime', {}),
  contentRequestStateData: _.get(state, 'contentRequestData.contentRequestData', {}),
  overallStatus: _.get(state, 'contentRequestData.contentRequestAccordianData.overAllStatus', false),
  typeOfContent: _.get(state, 'contentRequestData.contentRequestAccordianData.type', {}),
  selectAll: _.get(state, 'bulkImportCount.selectAll', {}),
  removeUnresolvedFeedbackCount: _.get(state, 'contentRequestData.contentRequestAccordianData.removeUnresolvedFeedbackCount', {}),
  removeUnresolvedFeedbackCountForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.removeUnresolvedFeedbackCountForTest', 0)
});
const mapdispatchtoprops = (dispatch: any) => bindActionCreators({
  setCountToImport,
  showMsg: showMsg,
  selectAllCheckbox: selectAllCheckbox,
  setSelectAll: setSelectAll,
  setSelectedQuestionsBySelectAll: setSelectedQuestionsBySelectAll,
  setIsClickedOnImport: contentRequestAccordianActions.setIsClickedOnImport,
  setRemoveUnresolvedFeedbackCount: contentRequestAccordianActions.setRemoveUnresolvedFeedbackCount,
  setRemoveUnresolvedFeedbackCountForTest: contentRequestAccordianActions.setRemoveUnresolvedFeedbackCountForTest

}, dispatch);


// @ts-ignore
export default connect(mapstatetoprops, mapdispatchtoprops)(withRouter(withStyles(styles)(MyPATQuestionBar)));
